export default function conjunctionFormat(value: Iterable<string>, language?: Intl.Locale): string {
  return new Intl.ListFormat(language, { style: 'long', type: 'conjunction' }).format(value)
}
